export default __webpack_public_path__ + "static/media/james3.43fb9999.png";